module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#rss",
      toString: function () {
        return this.url;
      }
    }